<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title title"></h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center py-4">
          <p
            class="mb-3"
            style="font-size: 18px; font-weight: 600; color: #090741"
          >
            Czy na pewno chcesz usunąć dane do faktury użytkownika?
          </p>
          <p style="font-size: 14px; color: rgba(9, 7, 65, 0.75)">
            Pamiętaj, że bez wprowadzonych danych do faktury nie można wystawić
            faktury!
          </p>
        </div>
        <div class="modal-footer justify-content-center">
          <CustomButton title="NIE" size="large" @click="closeModal" />
          <CustomButton
            title="TAK"
            size="large"
            :gradient="true"
            @click="confirmDelete"
          />
        </div>
        <!-- Hidden close trigger -->
        <button ref="dismissBtn" type="button" data-dismiss="modal" style="display: none;"></button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "./CustomButton.vue";

export default {
  name: "InvoiceDeleteConfirmModal",
  components: { CustomButton },
  props: ["modalId"],
  emits: ["confirm"],
  methods: {
    confirmDelete() {
      this.$emit("confirm");
      this.$refs.dismissBtn.click();
    },
    closeModal() {
      this.$refs.dismissBtn.click();
    },
  },
};
</script>
